/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_A5Inputs */

const en_diff_faq_a5 = /** @type {(inputs: Diff_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, but performance depends on your browser. For very large files (over 10 MB), the comparison may take a few seconds. All processing happens locally.`)
};

const ko_diff_faq_a5 = /** @type {(inputs: Diff_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네, 하지만 성능은 브라우저에 따라 다릅니다. 매우 큰 파일(10MB 이상)의 경우 비교에 몇 초가 걸릴 수 있습니다. 모든 처리는 로컬에서 이루어집니다.`)
};

const ja_diff_faq_a5 = /** @type {(inputs: Diff_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、ただしパフォーマンスはブラウザに依存します。非常に大きなファイル（10MB以上）の場合、比較に数秒かかることがあります。すべての処理はローカルで行われます。`)
};

/**
* | output |
* | --- |
* | "Yes, but performance depends on your browser. For very large files (over 10 MB), the comparison may take a few seconds. All processing happens locally." |
*
* @param {Diff_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_a5 = /** @type {((inputs?: Diff_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_a5(inputs)
	if (locale === "ko") return ko_diff_faq_a5(inputs)
	return ja_diff_faq_a5(inputs)
});